import { useContext, useEffect, useState } from "react";

import { PanelDefaultRoute } from "@src/router/routes";
import { UserContext } from "@src/utility/context/user";
import { decoColumns } from "./misc/deco-columns";
import { setItemToStore } from "@src/utility/helpers/utils";
import useAxios from "@hooks/use-axios";
import { useNavigate } from "react-router-dom";
import usePanelAbility from "@src/utility/hooks/use-panel-ability";
import useSearchParams from "@hooks/use-search-params";

const useOrganizations = () => {
    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "superAdmin",
        initialLoader: true
    });
    const [data, setData] = useState({ organizations: [], pagination: {} });
    const [queryParams, setQueryParams] = useState({});
    const { getSearchParams } = useSearchParams();
    const [modalConfig, setModalConfig] = useState({ isOpen: false, row: {} });

    const { handlePanelAbility } = usePanelAbility();
    const { handleUserData } = useContext(UserContext);
    const navigate = useNavigate();

    const handleModalConfig = (row = {}) => {
        setModalConfig((prev) => ({ row, isOpen: !prev.isOpen }));
    };

    const getOrganizations = async () => {
        const { data } = await axiosInstance.get("/superadmin/organizations", {
            params: {
                page : getSearchParams("page"),
                limit: getSearchParams("limit")
            }
        });

        setData({
            organizations: data?.data || [],
            pagination   : data?.pagination || {}
        });
    };

    const handleLoginAsAdmin = async (row) => {
        const { data } = await axiosInstance.post(
            `/superadmin/impersonate/${row?._id}`
        );

        const adminData = {
            user: {
                ...data?.user,
                role: "admin"
            },
            token: data?.["token"]
        };

        setItemToStore("token", data?.["token"]);
        handlePanelAbility({ userInfo: adminData });
        handleUserData(adminData);
        navigate(PanelDefaultRoute);
    };

    const handleRowActions = async (row = {}, action) => {
        if (action === "delete") {
            await axiosInstance.delete(`/organizations/${row._id}`);
            getOrganizations();
            return;
        }
        handleModalConfig(row);
    };

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getOrganizations();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    return {
        data,
        loading,
        columns: decoColumns({ handleLoginAsAdmin, handleRowActions }),
        setQueryParams,
        getOrganizations,
        handleModalConfig,
        modalConfig
    };
};

export default useOrganizations;
